/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_CostInputs */

const en_filter_cost = /** @type {(inputs: Filter_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost per portion`)
};

const de_filter_cost = /** @type {(inputs: Filter_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kosten pro Portion`)
};

/**
* | output |
* | --- |
* | "Cost per portion" |
*
* @param {Filter_CostInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_cost = /** @type {((inputs?: Filter_CostInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_CostInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_cost(inputs)
	return en_filter_cost(inputs)
});